/** Canvas attribute help (yellow-dot popovers). Keys are original Chinese. */
export default {
  "X 坐标": "X",
  "组件相对画布左上角的水平位置（像素）。": "Horizontal offset from the canvas top-left, in pixels.",
  "可在属性中输入，或在画布上拖拽组件。": "Type a value here, or drag the component on the canvas.",
  "影响预览与导出工程中的布局位置。": "Affects layout in preview and the exported project.",
  "Y 坐标": "Y",
  "组件相对画布左上角的垂直位置（像素）。": "Vertical offset from the canvas top-left, in pixels.",
  "宽度 W": "Width W",
  "组件显示宽度（像素）。": "Visible width in pixels.",
  "输入数值，或拖拽选中框左右边缘调整。": "Type a value, or drag the left/right handles.",
  "过小可能导致文字/图标显示不全。": "Too small may clip text or icons.",
  "高度 H": "Height H",
  "组件显示高度（像素）。": "Visible height in pixels.",
  "输入数值，或拖拽选中框上下边缘调整。": "Type a value, or drag the top/bottom handles.",
  "控制组件整体透明度。取值通常在 0～1 之间：1 完全不透明，0 完全透明（仍可能保留点击热区）。":
    "Overall opacity, usually 0–1. 1 is opaque; 0 is fully transparent (the hit area may remain).",
  "在「组件属性」中调节数值；也可通过「组件联动」在预览时动态改透明度做显隐动画。":
    "Adjust it under Component. You can also animate it via Links in preview.",
  "只影响观感；透明后若仍可点，注意热区不要误挡其它控件。":
    "Visual only. If it stays clickable, avoid covering other controls.",
  "按钮等组件四角的圆角半径（像素）。数值越大，角越圆；过大近似胶囊/圆形。":
    "Corner radius in pixels. Larger values round the corners; very large values look like a pill or circle.",
  "按 UI 稿填写；圆形按钮模板本身已带圆角策略，可再微调。":
    "Follow the UI spec. Round-button templates already include radius; tweak only if needed.",
  "仅外观，不改变实际点击区域计算方式。": "Visual only; the click area calculation does not change.",
  "文字字号。用于按钮名称、文本内容、滑块数值、可视化文件名等。":
    "Font size for button labels, text, slider values, visualization names, and similar.",
  "按画布分辨率选择合适字号；字号过大时请同步加大组件宽高。":
    "Pick a size for the canvas resolution. If type is large, also grow the component.",
  "过大易溢出裁切；过小在终端上不易阅读。": "Too large clips; too small is hard to read on the device.",
  "文字前景色。": "Text color.",
  "点选色板；注意与背景色对比度，保证可读。": "Pick a color with enough contrast against the background.",
  "仅外观。": "Visual only.",
  "滑块等组件上数值/标签的文字颜色。": "Text color for slider values and similar labels.",
  "与轨道、圆点颜色搭配，保证对比清晰。": "Contrast it with the track and thumb colors.",
  "工程内置字体包中的字体样式。": "A font from the project font pack.",
  "从下拉选择；特殊字体需确认终端客户端已内置对应资源。":
    "Choose from the list. Confirm the client includes special fonts.",
  "终端缺少字体时可能回退为默认字体，版式会变化。":
    "Missing fonts on the device fall back to the default and may reflow.",
  "组件或页面的纯色背景。当背景类型为「颜色」时生效；若同时配置了背景图，通常以图片为准。":
    "Solid fill when background type is Color. An image usually wins if both are set.",
  "先设背景类型为颜色，再选色值。页面背景会影响整页底色。":
    "Set type to Color, then pick a value. Page background tints the whole page.",
  "影响视觉层次；深色背景上注意改浅色文字。": "Affects visual hierarchy. Use light text on dark fills.",
  "在「颜色背景」与「图片背景」之间切换，决定下方显示哪一组配置项。":
    "Switch between color and image; the fields below follow the type.",
  "选颜色 → 调背景色；选图片 → 从素材库上传/选择背景图。按钮还有单独的「按压背景」类型。":
    "Color → fill. Image → pick from the library. Buttons also have a pressed background type.",
  "切换后另一类配置不会作为当前生效背景。": "The unused type is not the active background.",
  "使用图片作为组件背景（按钮常态、状态灯、可视化等）。":
    "Image fill for buttons, status lights, visualization, and similar.",
  "点击上传区打开素材库选择；可删除恢复默认。建议用与组件宽高接近的图，减少拉伸变形。":
    "Open the library from the upload area. Prefer images close to the component size.",
  "图片会计入工程资源，增大导出包；过大图片可能影响终端加载。":
    "Images are packed with the project. Oversized files slow the device.",
  "当前页面在左侧页树、跳转事件选页列表、以及终端菜单中显示的名称。":
    "Name shown in the page tree, jump lists, and the device menu.",
  "建议用业务语义命名（如「首页」「灯光控制」），避免「页面1、页面2」难以辨认。":
    "Use meaningful names (Home, Lighting) instead of Page 1, Page 2.",
  "改名后跳转配置里仍引用同一页面，显示文案会更新。":
    "Jumps still target the same page; only the displayed name changes.",
  "仅子页面有效：子页面画布逻辑宽度，默认约 1200。主页面使用工程顶栏宽高。":
    "Subpages only. Logical width, default about 1200. The main page uses the toolbar size.",
  "按嵌入区域设计调整；主页上的「子页面」组件占位会随该尺寸变化。":
    "Size it for the embed area. The subpage widget on the home page follows this size.",
  "过大会在主页显得拥挤；过小内部组件易挤在一起。":
    "Too large crowds the home page; too small packs inner widgets.",
  "仅子页面有效：子页面画布逻辑高度，默认约 700。":
    "Subpages only. Logical height, default about 700.",
  "与宽度一起规划子页版式；改完后到主页预览嵌入效果。":
    "Plan width and height together, then preview the embed on the home page.",
  "影响子页面组件在主页中的占位高度。": "Sets how tall the subpage widget is on the home page.",
  "编辑态是否在画布上显示网格辅助线，方便对齐。": "Show grid lines while editing to help alignment.",
  "需要精细对齐时打开；一般不影响终端最终画面。": "Turn on for precise layout. It does not show on the device.",
  "仅编辑辅助，便于布局。": "Editor aid only.",
  "页面级背景图，铺在当前页最底层。": "Page background image, behind all widgets.",
  "从素材库选择；可与背景色配合（图未铺满时露出底色）。":
    "Pick from the library. Fill color shows where the image does not cover.",
  "从素材库选择；可与「图片尺寸」配合：铺满拉伸填框，等比例完整显示（可能露出背景色）。":
    "Pick from the library; use Image size — fill stretches, contain shows all (may show background color).",
  "计入工程资源与导出体积。": "Counts toward project assets and export size.",
  "控制该页是否出现在终端侧菜单/页面列表中，方便用户主动进入。":
    "Whether the page appears in the device menu so users can open it.",
  "纯跳转中转页、弹层式子逻辑页可选「否」，避免菜单过长。":
    "Choose No for transit or overlay pages so the menu stays short.",
  "隐藏后仍可通过按钮「跳转事件」进入，只是菜单里找不到。":
    "Hidden pages can still be opened by jump events.",
  "「子页面」组件要嵌入显示哪一个已创建的子页内容。未绑定则只显示占位。":
    "Which subpage this widget embeds. Unbound widgets show a placeholder.",
  "先在页树新增子页面并完成内部布局，再回到主页选中子页面组件，在此下拉选择目标子页。":
    "Create and layout the subpage, then bind it here from the home page widget.",
  "预览/运行时渲染被绑定子页的全部组件；切换绑定会立刻换内容。子页面宽高由子页自身属性决定。":
    "Preview renders the bound page. Size comes from the subpage itself.",
  "按钮上的显示文字，或文字组件的正文内容。": "Button label, or body text for a text widget.",
  "直接编辑；按钮还可另配「按压名称」在按下时换文案。文字组件可再开滚动、允许变更等。":
    "Edit directly. Buttons can use a different pressed label. Text can scroll or allow changes.",
  "预览与终端上直接可见，是用户识别功能的主要文案。": "Visible in preview and on the device.",
  "按钮处于按压态时显示的文字，可与常态名称不同（例如「开启」/「关闭」）。":
    "Label while pressed, e.g. On / Off.",
  "填写后按压态优先显示该文案；常与按压背景、联动状态一起用。":
    "When set, pressed state uses this text with pressed background and links.",
  "提升状态可读性；留空则按压态仍显示常态名称。": "Leave empty to keep the normal label when pressed.",
  "按钮在工程内的逻辑标识，供定时、交互包、指令绑定等按名称引用。":
    "Logical id for timers, I/O packs, and command binding.",
  "开启「定时」等能力时务必填写，且全工程尽量唯一（如 light_on_1）。避免中文空格与特殊符号。":
    "Required for timers. Keep it unique (e.g. light_on_1). Avoid spaces and symbols.",
  "重复或为空可能导致校验失败、无法保存，或运行时找不到目标按钮。":
    "Duplicates or empty values can fail validation or break runtime lookup.",
  "点击后进入短暂加载态，期间通常不可再次触发，用于防连点、等设备反馈。":
    "Brief loading after click to prevent double-taps while waiting for the device.",
  "开启后设置「持续时间」秒数；适合发指令后需要等待的场景。":
    "Enable and set duration in seconds when commands need a wait.",
  "时间过短防不住连点；过长会让人感觉卡顿。": "Too short still double-fires; too long feels stuck.",
  "按钮 loading 持续的秒数。": "How many seconds loading lasts.",
  "配合「按钮 loading」开启；按指令往返时延估算（常见 0.5～2 秒）。":
    "Use with button loading. Typical 0.5–2s based on round-trip time.",
  "影响可再次点击的间隔。": "Controls when the button can be clicked again.",
  "是否启用与定时相关的按钮逻辑（与别名、后台定时策略配合）。":
    "Enable timer-related button logic with alias and backend schedules.",
  "开启后请填写唯一「别名」，并确认工程/后台侧定时配置已指向该别名。":
    "Then set a unique alias and point schedules at it.",
  "影响按钮是否参与定时触发；配置不全时可能校验不通过。":
    "Controls timer participation. Incomplete setup may fail validation.",
  "切换按钮工作模式：\n· 关闭（按压模式）：可配再次按压联动、两组指令等开关类交互；\n· 开启（单击模式）：可配跳转事件、点击绑定到其它组件事件。":
    "Mode switch.\nOff (press): second-press links and two command groups.\nOn (click): jumps and click-bind to other widgets.",
  "纯跳转、打开视频/轮播等一次动作 → 开单击；需要按一下开、再按一下关 → 关单击并配指令2/再次联动。":
    "One-shot jumps/media → click mode. Toggle on/off → press mode with command 2 / second-press links.",
  "会改变「事件配置」Tab 里出现的按钮项，保存前请确认事件是否仍符合预期。":
    "Changes which items appear on Events. Recheck events before save.",
  "点击按钮后先弹出确认框，用户点确认才真正执行指令/事件，用于防误触。":
    "Ask for confirmation before running commands or events.",
  "关机、清空、重要模式切换等建议开启。": "Use for power-off, clear, and other high-impact actions.",
  "多一步确认，指令不会立即下发。": "Commands wait until the user confirms.",
  "按压按钮时是否播放按键音。": "Play a click sound when pressed.",
  "需要操作反馈时开启；嘈杂环境或静音展厅可关闭。": "On for feedback; off in noisy or silent rooms.",
  "依赖终端是否支持对应音效资源。": "Needs sound support on the device.",
  "按压态用颜色还是图片，与常态背景独立配置，便于区分开/关态。":
    "Pressed fill is color or image, independent of the normal background.",
  "选颜色则配按压色；选图片则配按压背景图。建议与常态有明显差异。":
    "Color → pressed fill. Image → pressed image. Keep it distinct from normal.",
  "仅按压态外观；不改变指令逻辑。": "Pressed look only; commands are unchanged.",
  "按压背景类型为颜色时的填充色。": "Fill when pressed type is Color.",
  "在按压背景类型选「颜色」后配置。": "Set after pressed type is Color.",
  "按压态使用的背景图。": "Background image while pressed.",
  "从素材库选择；尺寸建议与按钮宽高一致。": "Pick from the library. Match button size.",
  "计入工程资源。": "Counts as a project asset.",
  "叠加在按钮文字旁/上的小图标，增强识别。": "Small icon next to or on the label.",
  "从可选图标列表中选择；无合适图标可不选。": "Pick from the list, or leave empty.",
  "运行时是否允许文本内容被组件联动、外部逻辑等改写。":
    "Allow Links or external logic to change the text at runtime.",
  "固定标题关掉；需要根据状态改字（如「已连接」）时打开。":
    "Off for static titles. On when text should follow state (e.g. Connected).",
  "关闭后外部/联动改字可能不生效。": "When off, external/link text updates may be ignored.",
  "文字相对组件区域过长时，是否以跑马灯方式滚动显示。":
    "Marquee when text is longer than the box.",
  "开启后配置滚动方向与速度；适合通知条、长标题。":
    "Then set direction and speed. Good for tickers and long titles.",
  "开启后静态排版感减弱，注意速度不要过快。": "Keep speed readable.",
  "文字滚动的方向（如水平左右）。": "Scroll direction (e.g. horizontal).",
  "先开启「文字滚动」，再选方向。": "Enable marquee first, then pick a direction.",
  "仅展示效果。": "Display only.",
  "文字滚动快慢。": "Marquee speed.",
  "按可读性调节：提示类可稍快，正文说明宜慢。": "Faster for alerts; slower for body copy.",
  "过快难以阅读；过慢信息吞吐低。": "Too fast is unreadable; too slow is sluggish.",
  "图片组件当前展示的素材。": "Image shown by the picture widget.",
  "从素材库选择；可与「图片尺寸适配」一起调裁切方式。":
    "Pick from the library and set fit (cover/contain).",
  "计入工程资源与导出包。": "Counts toward assets and the export package.",
  "图片在组件框内的铺满/等比例缩放等适配方式。": "How the image fits the box (cover vs contain).",
  "图片或页面背景在框内的铺满/等比例缩放适配方式。":
    "How a picture or page background fits its box (fill vs contain).",
  "需要铺满无留白选铺满（可能裁切）；需要完整显示选等比例（可能留边）。":
    "Cover fills (may crop). Contain shows all (may letterbox).",
  "需要铺满无留白选铺满（可能变形）；需要完整显示选等比例（可能留边露底色）。缺省为铺满，兼容未配置的老工程。":
    "Fill stretches (may distort). Contain shows all (may letterbox). Default fill; old projects without the field behave as fill.",
  "只影响裁剪与缩放显示，不改原图文件。": "Display only; the file is unchanged.",
  "配置监控等 RTSP 取流地址，可添加多组。\n示例（海康）：\nrtsp://admin:12345@192.168.1.64:554/ch1/sub/av stream\n【rtsp://】协议\n【admin】账号\n【12345】密码\n【IP】摄像机地址\n【554】端口\n后续为通道/码流路径（主码流/子码流以厂商文档为准）":
    "RTSP URLs (only the first group is played).\nExample:\nrtsp://admin:12345@192.168.1.64:554/ch1/sub/av stream",
  "配置监控等 RTSP 取流地址（运行时仅播放第一组，请只填一条）。\n示例（海康）：\nrtsp://admin:12345@192.168.1.64:554/ch1/sub/av stream\n【rtsp://】协议\n【admin】账号\n【12345】密码\n【IP】摄像机地址\n【554】端口\n后续为通道/码流路径（主码流/子码流以厂商文档为准）":
    "RTSP URL (runtime plays the first group only; configure one).\nExample:\nrtsp://admin:12345@192.168.1.64:554/ch1/sub/av stream",
  "按摄像机品牌文档填写完整 URL；局域网需保证终端能访问该 IP。可先在 VLC 等工具验证地址再填入。":
    "Use the camera vendor URL. The device must reach the IP. Test in VLC first if needed.",
  "只填一条流地址；按摄像机品牌文档填写完整 URL；局域网需保证终端能访问该 IP。可先在 VLC 等工具验证地址再填入。":
    "One stream URL only. Use the camera vendor URL. The device must reach the IP. Test in VLC first if needed.",
  "地址、账号或网络不通会导致黑屏/无法出流；多路流增加终端解码压力。":
    "Bad URL, auth, or network means a black screen.",
  "地址、账号或网络不通会导致黑屏/无法出流。历史工程若残留多组，终端仍只播第一组。":
    "Bad URL, auth, or network means a black screen. Extra groups in old projects are ignored; only the first plays.",
  "本平台暂不支持在项目中上传媒体素材。请在设备端本地配置平台上传对应文件，并确保此处填写的文件名称与设备上的实际文件名完全一致。":
    "This platform does not host media files. Put the file on the device and use the exact file name here.",
  "只填一条视频文件名（含扩展名）。需要讲解同步控设备时，到「事件配置」里按播放秒数绑定指令。":
    "One video file name with extension. For timed control, bind commands by second on Events.",
  "名称不一致时设备端无法找到对应文件，视频无法播放。":
    "If the name does not match, the device cannot play the video.",
  "只填一条音频文件名（含扩展名）；可开「循环播放」。常与按钮点击绑定配合做背景音。":
    "One audio file name with extension. Optional loop. Often bound to a button.",
  "名称不一致时设备端无法找到对应文件，音频无法播放。":
    "If the name does not match, the device cannot play the audio.",
  "音频是否循环播放。": "Loop audio.",
  "背景氛围音建议开启；一次性提示音关闭。": "On for ambience; off for one-shot cues.",
  "仅播放行为。": "Playback only.",
  "内嵌网页组件加载的 http/https 地址。": "http/https URL for the web widget.",
  "填写终端网络可达的地址；注意部分站点禁止 iframe 嵌套可能导致空白。":
    "Use a URL the device can reach. Some sites block iframes.",
  "依赖终端网络与页面兼容性；跨域/证书问题会导致打不开。":
    "Needs network and page compatibility. CORS/certs can fail.",
  "滑块轨道为横向或纵向，决定拖动手势方向。": "Horizontal or vertical track; sets drag direction.",
  "选定后调整组件宽高与轨道粗细，保证手指可操作区域足够。":
    "Then size the widget and track for touch.",
  "影响交互手势；改方向后建议重新检查布局。": "Recheck layout after changing direction.",
  "滑块拖动圆点的颜色。": "Thumb color.",
  "与轨道色、滑动色区分开，便于看清当前位置。": "Contrast it with track and active colors.",
  "滑块圆点直径，影响可点性与视觉比重。": "Thumb diameter; affects touch and visual weight.",
  "触屏场景宜稍大；过小不易拖准。": "Slightly larger on touch screens.",
  "过小难操作；过大可能挡住刻度文字。": "Too small is hard to drag; too large hides labels.",
  "滑块未激活（未滑过）轨道颜色。": "Inactive track color.",
  "选择与页面背景有一定对比的颜色。": "Contrast it with the page background.",
  "滑块已滑过区域的颜色，表示当前进度。": "Filled track color for current value.",
  "建议用品牌主色或高对比色。": "Use a brand or high-contrast color.",
  "滑块轨道粗细。": "Track thickness.",
  "按设计调节；过细不易看清进度。": "Too thin hides progress.",
  "只填一条文档文件名（含扩展名），确认终端支持该格式。":
    "One document file name with extension. Confirm the device supports the format.",
  "名称不一致时设备端无法打开对应文档。": "If the name does not match, the document will not open.",
  "天气组件查询天气所对应的城市。": "City used by the weather widget.",
  "选择或填写正确城市名；需终端能访问天气数据服务。":
    "Use the correct city. The device needs weather service access.",
  "城市错误则显示其它地区天气。": "A wrong city shows the wrong forecast.",
  "天气图标与版式风格（由后台样式列表提供）。": "Weather icon/layout style from the backend list.",
  "从下拉选择与整体 UI 匹配的样式。": "Pick a style that matches the UI.",
  "多图轮播依次展示的图片集合。": "Images shown in sequence.",
  "按展示顺序添加多张图，并设置「轮播间隔」；可配图片尺寸适配。":
    "Add images in order, set interval, and choose fit.",
  "图片多、分辨率高会增大包体与内存占用。": "Many large images grow package size and memory.",
  "自动切换到下一张的间隔秒数。": "Seconds between slides.",
  "宣传图可 3～8 秒；信息密集时可稍长。": "About 3–8s for promo; longer for dense info.",
  "过短闪烁刺眼；过长像静态图。": "Too short flickers; too long looks static.",
  "状态灯在不同监测/回码结果下展示的背景（颜色或图片），用于表达在线、离线、开、关等。":
    "Status-light fill (color or image) for online/offline/on/off results.",
  "先配「网络状态」或「开关状态」逻辑，再为各结果态设置对应外观，保证用户一眼能区分。":
    "Configure network or switch logic first, then a distinct look per result.",
  "与网络状态/开关状态结果联动；未配结果态时观感不完整。":
    "Follows network/switch results. Incomplete looks unfinished.",
  "可视化组件列表项如何展示：缩略图+文件名 / 仅缩略图 / 仅文件名等。":
    "How list items show: thumb+name, thumb only, or name only.",
  "按触控屏信息密度选择；同时在「网络配置」填服务 IP、播放器 IP、素材根目录。":
    "Pick density for the touch screen. Also set IPs and media root on Network.",
  "影响终端如何拉取与展示可视化内容；网络参数错误则列表为空。":
    "Wrong network settings yield an empty list.",
  "按钮等触发时下发的主指令列表，通常对应按下或主动作。":
    "Primary commands sent on press / main action.",
  "点「添加指令」从指令库勾选，可多条按顺序下发；先确认目标设备 IP/端口正确。":
    "Add commands from the library, in order. Confirm IP/port first.",
  "直接决定设备收到的控制内容；错指令可能导致误动作，重要操作建议加弹窗确认。":
    "This is what the device runs. Use confirm for high-impact actions.",
  "第二组指令，常用于再次按压、抬起或开关成对动作。单击模式下入口可能隐藏。":
    "Second command group for second press / release. Hidden in click mode.",
  "与第一组配合：例如指令1=开、指令2=关；保存前用预览验证两次按压是否符合预期。":
    "Pair with group 1 (on/off). Preview both presses before save.",
  "影响二次触发时的下发内容。": "What is sent on the second trigger.",
  "组件网络通信目标设备/服务的 IPv4 地址。": "IPv4 of the target device or service.",
  "填写局域网可达地址；保存前注意格式校验。环境组件、滑块、矩阵、生态组、可视化等均依赖此项。":
    "Use a reachable LAN address. Required by environment, slider, matrix, eco, visualization.",
  "错误则指令或状态监测无法连通。": "Wrong IP breaks commands and status.",
  "目标服务端口号，与 IP 成对使用。": "Service port, paired with IP.",
  "按设备协议或中控服务文档填写。": "From the device or control-service docs.",
  "端口不通表现为超时、无响应。": "A bad port times out or stays silent.",
  "矩阵「输入」按键对应的输入位标识，供执行键规则中的 X 引用。":
    "Matrix input id, referenced as X in execute rules.",
  "按现场矩阵方案编号填写，并与「执行」键规则一致。":
    "Use the site numbering and keep it consistent with execute rules.",
  "填错会导致切换到错误输入源。": "Wrong values switch the wrong input.",
  "矩阵「输出」按键对应的输出位标识，供执行键规则中的 Y 引用。":
    "Matrix output id, referenced as Y in execute rules.",
  "与输入位、规则引擎统一规划编号。": "Keep numbering aligned with inputs and the rule engine.",
  "填错会导致输出通道错误。": "Wrong values switch the wrong output.",
  "矩阵「执行」键的规则表达式。界面提示：X=输入位，Y=输出位。":
    "Execute-key expression. X = input, Y = output.",
  "按提示编写规则，并配置执行端 IP/端口；先配好输入/输出键再写规则。":
    "Write the rule, set execute IP/port, after input/output keys exist.",
  "决定按下执行键时如何组合输入与输出。": "How input and output combine on execute.",
  "滑块可切换的「单位 + 代码」列表，用于同一滑块下发不同量纲或协议字段。":
    "Unit + code rows so one slider can send different fields.",
  "至少配置 2 组；每组填写单位名称与对应代码，保存前通过校验。拖动滑块时按当前单元组装下发值。":
    "At least two units. Dragging sends the value for the active unit.",
  "单元或代码错误会导致设备收到无法识别的数值。": "Wrong units/codes send values the device rejects.",
  "可视化场景中播放器或相关服务的 IP。": "Player / related service IP for visualization.",
  "按现场部署填写，需与服务端、素材服务网络互通。": "Must reach the media and backend services.",
  "不通则无法取流/取列表。": "If unreachable, lists and streams fail.",
  "可视化播放器服务端口。": "Visualization player port.",
  "与播放器 IP 成对配置。": "Paired with player IP.",
  "连通性。": "Connectivity.",
  "可视化素材在服务上的根路径。": "Media root path on the server.",
  "填写服务真实目录路径，注意大小写与斜杠；改目录后需确认文件仍在其下。":
    "Use the real path (case and slashes). Confirm files still live under it after moves.",
  "路径错误会导致资源找不到、列表为空。": "A bad path yields an empty list.",
  "多个按钮组成互斥组：按下其中一个时，其它已绑定按钮进入指定状态（如释放），类似单选。":
    "Mutex group: pressing one releases the others, like radio buttons.",
  "点按钮打开弹窗，勾选同组其它按钮及目标状态；常用于模式切换（只允许一种模式按下）。":
    "Pick sibling buttons and target states. Typical for exclusive modes.",
  "避免多按钮同时保持按下；与联动事件不同，侧重「互斥释放」。":
    "Prevents several buttons staying pressed. Unlike links, this is exclusive release.",
  "点击后跳转到工程内其它页面。需开启「是否单击按钮」后才出现该入口。":
    "Jump to another page. Requires click mode.",
  "在弹窗中选择目标页；可与网络指令同时配置（先发指令再跳转，或按产品实际顺序）。":
    "Choose the target page. Can run with network commands.",
  "改变当前显示页面；目标页若懒加载，首次进入可能有短暂加载。":
    "Switches the page. Lazy-loaded pages may pause on first open.",
  "按下本按钮时，联动改变其它按钮的按压/释放状态，用于一键场景。":
    "Pressing this button sets other buttons' pressed/released state.",
  "弹窗中勾选被联动按钮及目标状态；可与互斥、指令一起用。":
    "Pick targets and states. Can mix with mutex and commands.",
  "批量改变界面状态，不替代网络指令本身（指令仍在网络配置里）。":
    "UI state only. Commands still live on Network.",
  "再次按压（抬起成对动作）时的状态联动。未开启「单击按钮」时可用。":
    "Link on second press / release. Available when click mode is off.",
  "配置「第二次动作」时其它按钮应处的状态，常与开关逻辑、指令2配合。":
    "State of others on the second action, often with command 2.",
  "决定关/松手时的界面恢复效果。": "How the UI restores on off / release.",
  "视频播放到指定秒数时自动下发指令，用于讲解/演示与设备同步。":
    "Send commands when video reaches a timestamp.",
  "在事件里点「添加」增加时间点，填写秒数并「添加指令」；可配多条时间轴。":
    "Add timestamps, set seconds, then add commands.",
  "秒数不准会感觉不同步；指令错误仍会影响设备。":
    "Wrong seconds feel out of sync. Wrong commands still hit the device.",
  "单击模式下，把本按钮的点击映射到其它组件的某个事件（如视频播放、轮播翻页、音乐播放、打开网页）。":
    "In click mode, map this click to another widget event (play, next, web, …).",
  "开启「是否单击按钮」→ 事件配置里先选组件再选事件；被绑组件需已在本页存在。":
    "Turn on click mode, then pick a widget and event on Events. It must exist on this page.",
  "点击本按钮等同触发目标组件事件，减少重复控件。":
    "This click fires the target event, so you need fewer widgets.",
  "被监测设备的显示名称，便于在多设备列表中区分。": "Display name to tell devices apart.",
  "用现场习惯命名（如「主机房交换机」）；一般不参与协议字段。":
    "Use site names. Usually not part of the protocol.",
  "主要用于识别与运维可读性。": "For operators, not the wire protocol.",
  "主动探测（Ping 等）或被动监测所针对的设备 IP。": "IP for ping or passive monitoring.",
  "填写真实可达地址；与端口、探测参数一起保存后预览验证灯态。":
    "Use a reachable IP. Preview the light after save.",
  "错误则灯态无法反映真实设备。": "A wrong IP makes the light lie.",
  "是否记录状态变化日志，便于排查误报/漏报。": "Log state changes for false/missed alarms.",
  "联调阶段建议开启，稳定后可按需关闭。": "On during commissioning; optional later.",
  "可能增加日志量。": "Can increase log volume.",
  "状态监测相关的指令绑定（如探测附带指令、开关态关联指令）。":
    "Commands tied to monitoring (probe extras, switch results).",
  "点添加从指令库选择；与成功/失败或回码表现一起配置。":
    "Add from the library together with success/fail or ack looks.",
  "影响监测过程是否附带控制，或回码如何对应。": "Whether probes also control, and how acks map.",
  "开关状态下可配置多台设备，各自有绑定指令、探测与回码表现。":
    "Switch mode can list many devices, each with commands and acks.",
  "点「添加设备」，逐台填写；展开折叠面板编辑。": "Add Device, then edit each panel.",
  "多设备时注意性能与回码冲突，避免多台规则互相覆盖灯态。":
    "Watch performance and conflicting acks that overwrite the light.",
  "当前选中组件的外观与业务相关配置，随组件类型变化（按钮、视频、状态灯等字段不同）。":
    "Look and behavior for the selection. Fields change by widget type.",
  "逐项填写；标签前带橘黄小圆点的可点击查看该功能的详细说明（用途、用法、影响）。":
    "Fill each field. Yellow dots open How / Effect help.",
  "决定显示效果与部分运行行为；改完建议预览验证。": "Preview after edits.",
  "监听其它组件的事件，触发时修改本组件若干属性（如透明度、颜色、图片）。仅在预览/运行生效，编辑态不一定立刻表现。":
    "Listen to other widgets and change opacity/color/image. Preview/runtime only.",
  "选择监听的组件 → 选择事件 → 配置要改的属性与目标值 → 可设过渡时间（毫秒）。用于显隐、换色、换图等动画。":
    "Pick source → event → properties and values → optional duration (ms).",
  "不替代网络指令下发；复杂联动建议命名清晰并预览逐步验证。":
    "Does not replace network commands. Preview complex links step by step.",
  "组件与外部设备/服务通信的指令与连接参数（IP、端口、指令、矩阵位、滑块单元等）。":
    "Commands and connection params (IP, port, matrix, slider units).",
  "按组件类型填写；带橘黄点的项可点开看说明。改完务必预览或联调设备。":
    "Fill by widget type. Yellow dots explain fields. Preview or test on device.",
  "直接影响控制是否成功、控制的是哪台设备。": "Decides whether control works and which device.",
  "点击后的页面跳转、按钮互斥/联动、视频时间点指令、单击绑定等交互。":
    "Jumps, mutex/links, video timestamps, click-bind.",
  "先确认按钮是否「单击」模式，再配置对应事件按钮；每项前的橘黄点有详细说明。":
    "Check click vs press mode first. Yellow dots explain each event.",
  "决定用户操作后的页面与状态变化，可与网络指令同时存在。":
    "Page and state after the tap. Can run with network commands.",
  "工程级协议与指令编排、按钮状态规则的集中入口（工具栏「交互包」），与单个组件属性面板独立。":
    "Project-level protocols and button-state rules (toolbar I/O pack), separate from the property panel.",
  "先添加协议（UDP/TCP/HTTP）→ 配指令集或按钮状态规则 → 与工程一并保存。":
    "Add protocol → command set or button rules → save with the project.",
  "影响外部消息驱动界面/指令的统一行为。": "How inbound messages drive UI and commands.",
  "配置组件与外部设备通信所需的 IP、端口、指令、矩阵位或滑块单元等。":
    "IP, port, commands, matrix bits, or slider units for the device.",
  "选中带网络能力的组件后出现本 Tab；按类型填写，并通过「添加指令」绑定下发内容。字段前橘黄点可查看细项说明。":
    "Shown for network-capable widgets. Add commands here. Yellow dots explain fields.",
  "直接决定点击/滑动等操作能否正确控制设备。": "Whether click/slide actually controls the device.",
  "配置点击后的页面跳转、按钮互斥/联动，或视频按秒触发指令等。":
    "Jumps, mutex/links, or commands at video seconds.",
  "按钮：可配互斥、联动；开启「单击按钮」后可配跳转与点击绑定；未开启时可配再次按压联动。\n视频：按播放秒数绑定指令。\n点橘黄点可看每个事件的详细用法。":
    "Buttons: mutex/links; click mode adds jump and click-bind; press mode adds second-press links.\nVideo: commands by playback second.\nYellow dots explain each event.",
  "决定用户操作后的页面切换与状态变化，可与网络指令同时生效。":
    "Page and state after the action. Can run with network commands.",
  "状态灯通过 Ping 等方式主动探测设备在线/离线，并切换灯的表现（颜色/图片）。":
    "The light pings the device and switches color/image for online/offline.",
  "填写设备名、IP、端口与探测相关参数；配置探测成功/失败时的显示。联调时建议打开状态 log。":
    "Set name, IP, port, and success/fail looks. Turn on status log while commissioning.",
  "用于运维可视监测，不替代按钮发指令；网络不通时灯会显示失败态。":
    "Monitoring only, not a substitute for button commands. Unreachable devices show fail.",
  "状态灯根据设备回码、绑定指令结果，被动反映开关类状态，支持多设备。":
    "The light follows device acks and bound commands. Multiple devices supported.",
  "添加设备 → 配绑定指令、探测时间与回码表现 → 再在组件属性里配各结果态背景。":
    "Add devices → commands, probe time, acks → then result looks on Component.",
  "用于把设备真实开关反馈到界面；回码规则配错会出现误亮/不亮。":
    "Maps real on/off to the UI. Bad ack rules mis-light the lamp.",
  "基本属性": "Properties",
  "网络配置": "Network",
  "事件配置": "Events",
  "网络状态": "Network status",
  "开关状态": "Switch status",
  "请选择组件": "Select a component",
  "铺满": "Cover",
  "等比例缩放": "Contain",
  "从左到右": "Left to right",
  "从右到左": "Right to left",
  "新页面": "Page ",
  "添加指令": "Add command",
  "添加设备": "Add device",
  "回码信息": "Ack",
  "设备": "Device",
};
